import { Pipe, PipeTransform } from '@angular/core';
import { ConfigService } from '../services/config.service'

@Pipe({name: 'assets'})
export class AssetsPipe implements PipeTransform {
  constructor(private gv:ConfigService){}
  
  transform(value: string): string {
        return this.gv.getString('assets') + (value ? value:'');
  }
}